import { Injectable } from '@angular/core';

const TENANT_GUID_KEY = 'trieonhr_tenant_guid';
const COMPANY_CODE_KEY = 'trieonhr_company_code';

/**
 * Persists SaaS workspace identity across login sessions.
 * Company code is the public slug; TenantGuid is resolved for API login.
 */
@Injectable({ providedIn: 'root' })
export class TenantContextService {
  getTenantGuid(): string | null {
    const value = localStorage.getItem(TENANT_GUID_KEY);
    return value && value.trim() ? value.trim() : null;
  }

  setTenantGuid(tenantGuid: string | null | undefined): void {
    const value = (tenantGuid ?? '').trim();
    if (!value) {
      localStorage.removeItem(TENANT_GUID_KEY);
      return;
    }
    localStorage.setItem(TENANT_GUID_KEY, value);
  }

  getCompanyCode(): string | null {
    const value = localStorage.getItem(COMPANY_CODE_KEY);
    return value && value.trim() ? value.trim().toLowerCase() : null;
  }

  setCompanyCode(companyCode: string | null | undefined): void {
    const value = (companyCode ?? '').trim().toLowerCase();
    if (!value) {
      localStorage.removeItem(COMPANY_CODE_KEY);
      return;
    }
    localStorage.setItem(COMPANY_CODE_KEY, value);
  }

  clear(): void {
    localStorage.removeItem(TENANT_GUID_KEY);
    localStorage.removeItem(COMPANY_CODE_KEY);
  }

  isValidGuid(value: string | null | undefined): boolean {
    if (!value) return false;
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
      value.trim()
    );
  }

  isValidCompanyCode(value: string | null | undefined): boolean {
    if (!value) return false;
    return /^[a-z0-9](?:[a-z0-9-]{0,46}[a-z0-9])?$/.test(value.trim().toLowerCase());
  }
}
